import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import Toggle from '/@/components/forms/toggle';
import styles from './styles.module.css';

@autobind
export default class ToggleGroup extends Component {
    static propTypes = {
        type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
        theme: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.any.isRequired,
                label: PropTypes.any.isRequired,
            })
        ).isRequired,
        max: PropTypes.number,
        value: PropTypes.arrayOf(PropTypes.number).isRequired,
        onChange: PropTypes.func.isRequired,
        direction: PropTypes.bool,
    };

    static defaultProps = {
        direction: false,
    };

    handleChange(option) {
        const { value, onChange } = this.props;
        return (checked) => {
            if (checked && !value.includes(option.value)) onChange([...value, option.value]);
            else if (!checked && value.includes(option.value)) onChange(value.filter((v) => v !== option.value));
        };
    }

    render() {
        const { type, options, value, max, direction } = this.props;

        const classNameRoot = classNames(styles.root, direction && styles.direction);

        return (
            <div className={classNameRoot}>
                {options.map((option) => {
                    const selected = value.includes(option.value);
                    const disabled = max !== undefined && !selected && value.length === max;
                    return (
                        <Toggle
                            key={option.value}
                            type={type}
                            theme={this.props.theme}
                            label={option.label}
                            value={selected}
                            disabled={disabled}
                            onChange={this.handleChange(option)}
                        />
                    );
                })}
            </div>
        );
    }
}
